import script from "./GgmsEmojiPicker.vue?vue&type=script&lang=ts&setup=true"
export * from "./GgmsEmojiPicker.vue?vue&type=script&lang=ts&setup=true"

import "./GgmsEmojiPicker.vue?vue&type=style&index=0&id=d3d68b98&scoped%3Adeep=true&lang=css"

const __exports__ = script;

export default __exports__